import styled from '@emotion/styled';

import { minDesktop } from '../styles/breakpoints';
import { Headline2ndFont } from '../styles/fonts';

export default styled.h2`
  ${Headline2ndFont};
  font-size: 26px;

  line-height: 1;

  ${minDesktop} {
    font-size: 32px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/H2/H2.js